<template>
    <div class="promotion-bar w-full px-5 py-1 bg-kbred flex justify-center border-1 border-kbred mb-3" v-if="topBannerShow">
        <div class="font-bold text-sm hidden ts:block text-white">Yeni yıl tatili sebebi ile ürün gönderimleri ve iade incelemeleri 5 Ocak Pazartesi günü başlayacaktır. Anlayışınız için teşekkür ederiz. İyi seneler 🎄</div>
        <div class="font-bold text-xs font-santralregular block ts:hidden text-center text-white">Yeni yıl tatili sebebi ile ürün gönderimleri ve iade incelemeleri 5 Ocak Pazartesi günü başlayacaktır. Anlayışınız için teşekkür ederiz. İyi seneler 🎄</div>
    </div>
    <BasketNotification :cart="auth?.cart?.items || []" :show="showBasketNotification" :optimistic-item="optimisticCartItem" :panel-class="basketPanelClass" />
    <div class="">
        <LayoutDemoPartnerHeader v-if="isPartnerLayout" />
        <LayoutDemoHeader v-else :auth="auth" :menu-items="menuItems" :wishlist="wishlist" :cart="cart" :is-aynet="isAynet" :institutional-layout="institutionalLayout" :logo-url="logoUrl" :logo-link="logoLink" />
        <slot />
        <LayoutDemoFooter :auth="auth" @subscribe-success="isOpen = true" />
    </div>
    <TransitionRoot appear :show="isOpen" as="template">
        <Dialog as="div" @close="closeModal" class="relative z-60">
            <TransitionChild as="template" enter="duration-300 ease-out" enter-from="opacity-0" enter-to="opacity-100" leave="duration-200 ease-in" leave-from="opacity-100" leave-to="opacity-0">
                <div class="fixed inset-0 bg-black bg-opacity-25" />
            </TransitionChild>

            <div class="fixed inset-0 overflow-y-auto">
                <div class="flex min-h-full items-center justify-center p-4 text-center">
                    <TransitionChild as="template" enter="duration-300 ease-out" enter-from="opacity-0 scale-95" enter-to="opacity-100 scale-100" leave="duration-200 ease-in" leave-from="opacity-100 scale-100" leave-to="opacity-0 scale-95">
                        <DialogPanel class="w-full max-w-md transform overflow-hidden rounded-2xl bg-white px-5 py-5 z-70 text-left align-middle shadow-xl transition-all flex flex-col justify-center items-center">
                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 62.051 62.051">
                                <g id="Group_4884" data-name="Group 4884" transform="translate(-73.036 -250.295)">
                                    <circle id="Ellipse_199" data-name="Ellipse 199" cx="31.025" cy="31.025" r="31.025" transform="translate(73.036 250.295)" fill="#70d44b" />
                                    <path id="Path_3299" data-name="Path 3299" d="M351.649,476.232a3.45,3.45,0,0,1-2.761-1.381l-8.464-11.286a3.451,3.451,0,0,1,5.522-4.141l5.538,7.383,14.223-21.334a3.451,3.451,0,1,1,5.743,3.829l-16.928,25.393a3.453,3.453,0,0,1-2.776,1.536Z" transform="translate(-251.82 -178.764)" fill="#fff" />
                                </g>
                            </svg>
                            <DialogTitle>
                                <h2 class="text-base font-semibold text-center mb-2 mt-2">Teşekkürler</h2>
                            </DialogTitle>
                            <p class="text-xs font-kiralabunuthin ts:text-sm text-center">Yenilikler ve indirimler için aboneliğiniz oluşturuldu.</p>
                            <!--                            <div class="mt-4">-->
                            <!--                                <button-->
                            <!--                                    type="button"-->
                            <!--                                    class="inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"-->
                            <!--                                    @click="closeModal"-->
                            <!--                                >-->
                            <!--                                    Got it, thanks!-->
                            <!--                                </button>-->
                            <!--                            </div>-->
                            <div class="absolute top-2 right-5 cursor-pointer p-2" @click="closeModal">x</div>
                        </DialogPanel>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>

    <!-- Email Abonelik Modal -->
    <TransitionRoot appear :show="false" as="template">
        <Dialog as="div" @close="closeEmailSubscribeModal" class="relative z-60">
            <TransitionChild as="template" enter="duration-300 ease-out" enter-from="opacity-0" enter-to="opacity-100" leave="duration-200 ease-in" leave-from="opacity-100" leave-to="opacity-0">
                <div class="fixed inset-0 bg-black bg-opacity-25" />
            </TransitionChild>
            <div class="fixed inset-0 overflow-y-auto">
                <div class="flex min-h-full items-center justify-center p-4 text-center">
                    <TransitionChild as="template" enter="duration-300 ease-out" enter-from="opacity-0 scale-95" enter-to="opacity-100 scale-100" leave="duration-200 ease-in" leave-from="opacity-100 scale-100" leave-to="opacity-0 scale-95">
                        <DialogPanel class="w-full max-w-[320px] ts:max-w-4xl transform overflow-hidden rounded-2xl bg-white p-0 z-999 text-left align-middle shadow-xl transition-all">
                            <div class="flex flex-col ts:flex-row min-h-[550px]">
                                <!-- Sol Taraf - Promosyon -->
                                <div class="w-full ts:w-1/2 bg-gradient-to-br from-[#9AE65C] to-[#70D44B] flex flex-col items-center justify-center relative">
                                    <Link href="kategoriler/tum-urunler" class="w-full h-full">
                                        <img src="../../../images/popup/popup.png" alt="Email Subscribe Modal Image" class="w-full" />
                                    </Link>
                                </div>

                                <!-- Sağ Taraf - Form -->
                                <div class="w-full ts:w-1/2 px-4 ts:px-8 py-16 bg-gray-50 relative flex flex-col justify-center">
                                    <div class="absolute top-4 right-4 cursor-pointer p-2" @click="closeEmailSubscribeModal">
                                        <span class="text-4xl font-bold text-black hover:text-gray-600">×</span>
                                    </div>

                                    <div class="max-w-lg mx-auto w-full">
                                        <DialogTitle class="text-lg font-semibold text-gray-800 mb-8 ts:mb-8 text-center leading-tight"> İndirimli kampanyalardan ilk senin haberin olsun istiyorsan</DialogTitle>

                                        <form @submit.prevent="submitEmailSubscribe" class="space-y-8">
                                            <input type="hidden" name="_token" :value="$page.props.csrf_token" />
                                            <div>
                                                <input type="email" v-model="emailSubscribeForm.email" class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-1 focus:ring-[#70D44B] focus:border-transparent text-gray-600 text-sm" placeholder="Mail Adresi" required />
                                            </div>
                                            <div class="flex justify-center">
                                                <button
                                                    :disabled="emailSubscribeForm.email == null || emailSubscribeForm.email == ''"
                                                    type="submit"
                                                    class="w-full max-w-[180px] border border-kbgreen text-kbgreen font-semibold py-1 px-3 rounded-lg hover:bg-kbgreen hover:text-white transition duration-200 tracking-wider text-lg font-bold font-santralregular disabled:border-gray-300 disabled:text-gray-300 disabled:bg-white"
                                                >
                                                    Abone ol
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </DialogPanel>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>
</template>

<script>
    import { Link, useForm } from "@inertiajs/vue3";
    import LayoutDemoFooter from "@/Pages/Shared/LayoutDemoFooter.vue";
    import LayoutDemoHeader from "@/Pages/Shared/LayoutDemoHeader.vue";
    import LayoutDemoPartnerHeader from "@/Pages/Shared/LayoutDemoPartnerHeader.vue";
    // import MobileMenu from "@/Pages/MobileMenu.vue";
    import BasketNotification from "@/Pages/Shared/basketNotification.vue";
    import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from "@headlessui/vue";
    import { eventBus } from "@/eventBus.js";

    import inertiaEvents from "@/Mixins/inertiaEvents.js";

    export default {
        mixins: [inertiaEvents],
        computed: {
            basketNotification() {
                return basketNotification;
            },
            showBasketNotification() {
                console.log("[BasketNotification] Computed show:", this.showBasketNotificationOptimistic);
                return this.showBasketNotificationOptimistic;
            },
            isPartnerLayout() {
                if (this.layoutVariant === "partner") {
                    return true;
                }

                const url = this.$page?.url || (typeof window !== "undefined" ? window.location.pathname : "");
                return url.includes("/isbirlikleri/partner-network");
            },
        },
        components: {
            BasketNotification,
            // MobileMenu,
            Link,
            TransitionRoot,
            TransitionChild,
            Dialog,
            DialogPanel,
            DialogTitle,
            LayoutDemoFooter,
            LayoutDemoHeader,
            LayoutDemoPartnerHeader,
        },
        data() {
            return {
                modalIsOpen: true,
                userCart: null,
                userCartLength: 0,
                showBasketNotificationOptimistic: false,
                optimisticCartItem: null,
                basketPanelClass: "",
                emailSubscribeForm: useForm({
                    email: null,
                }),
                logoUrl: "/images/logo.png",
                logoLink: "/",
                hideTopMenu: false,
                isOpen: false,
                emailSubscribeModalOpen: false,
                topbar: true,
                topBannerShow: false,
                affiliateObj: {},
                institutionalLayout: null,
            };
        },
        props: {
            menuItems: Object,
            menuItemsMobile: Object,
            auth: Object,
            apiEP: String,
            wishlist: Number,
            cart: Number,
            affiliate: String,
            newsletterPopupConfig: {
                type: Object,
                default: () => ({
                    enabled: true,
                    frequencyHours: 24,
                    delayMs: 3000,
                }),
            },
            isAynet: {
                type: Boolean,
                default: false,
            },
            layoutVariant: {
                type: String,
                default: null,
            },
        },
        methods: {
            getSafeLocalStorage() {
                try {
                    if (typeof window === "undefined") {
                        return null;
                    }

                    const storage = window.localStorage;
                    const testKey = "__storage_test__";
                    storage.setItem(testKey, testKey);
                    storage.removeItem(testKey);

                    return storage;
                } catch (e) {
                    return null;
                }
            },
            // toggleMenu() {
            //     this.menu = false;
            //     setTimeout(() => {
            //         //this.menu = false;
            //     }, 300);
            // },
            closeModal() {
                console.log(this.isOpen);
                this.isOpen = false;
            },
            openEmailSubscribeModal() {
                this.emailSubscribeModalOpen = true;
            },
            closeEmailSubscribeModal() {
                this.emailSubscribeModalOpen = false;
            },
            submitEmailSubscribe() {
                if (this.emailSubscribeForm.email == null || this.emailSubscribeForm.email == "") return;
                if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.emailSubscribeForm.email)) {
                    this.emailSubscribeForm.post(route("subscriber.subscribe"), {
                        onSuccess: () => {
                            this.closeEmailSubscribeModal();
                            this.isOpen = true;
                            this.emailSubscribeForm.reset();
                        },
                        onError: () => {
                            // Hata durumunda modal açık kalır, hata mesajları gösterilir
                        },
                    });
                }
            },
            closeBolBolModal() {
                console.log(this.modalIsOpen);
                this.modalIsOpen = false;
            },
            openBolBolModal() {
                this.modalIsOpen = true;
            },
            toggleBar() {
                this.topbar = !this.topbar;
            },
            checkAndShowSubscribeModal() {
                // Popup devre dışıysa gösterme
                if (!this.newsletterPopupConfig.enabled) {
                    return;
                }

                // Giriş yapmış kullanıcıya popup gösterme
                if (this.auth.isUserLoggedIn) {
                    return;
                }

                // Eğer frequencyHours 0 ise, zaman kontrolü yapma (her zaman göster)
                if (this.newsletterPopupConfig.frequencyHours > 0) {
                    const storage = this.getSafeLocalStorage();
                    if (!storage) return;
                    // localStorage'dan son popup gösterim zamanını kontrol et
                    const lastShownTimestamp = storage.getItem("newsletter_popup_last_shown_timestamp");
                    const now = Date.now();

                    // Eğer daha önce gösterilmişse, belirlenen süre geçmiş mi kontrol et
                    if (lastShownTimestamp) {
                        const hoursPassed = (now - parseInt(lastShownTimestamp)) / (1000 * 60 * 60);

                        // Belirlenen saat süresi geçmemişse popup gösterme
                        if (hoursPassed < this.newsletterPopupConfig.frequencyHours) {
                            return;
                        }
                    }

                    // Popup'ı göster ve zamanı kaydet
                    setTimeout(() => {
                        this.openEmailSubscribeModal();
                        // Gösterim zamanını timestamp olarak kaydet
                        storage.setItem("newsletter_popup_last_shown_timestamp", now.toString());
                    }, this.newsletterPopupConfig.delayMs);
                } else {
                    // frequencyHours = 0 ise her zaman göster (zaman kaydı yapma)
                    setTimeout(() => {
                        this.openEmailSubscribeModal();
                    }, this.newsletterPopupConfig.delayMs);
                }
            },
            newMessage(something) {
                console.log("newMessage", something);
                //this.$vueEventBus.$emit("message-in", something);
            },
        },
        watch: {
            showBasketNotification(newVal) {
                console.log("[BasketNotification] showBasketNotification changed:", newVal);
            },
        },
        mounted() {
            const storage = this.getSafeLocalStorage();
            if (storage) {
                try {
                    const userCart = storage.getItem("userCart");
                    this.userCart = userCart ? JSON.parse(userCart) : [];
                } catch (e) {
                    this.userCart = [];
                }
            } else {
                this.userCart = [];
            }
            // this.userCartLength = this.userCart.length;

            // Listen for immediate basket notification (optimistic UI)
            // Payload: cart item (ProductDetail) OR { item, panelClass } (TryBeforeYouBuy)
            eventBus.on("show-basket-notification", (payload) => {
                console.log("[BasketNotification] EventBus show triggered with item:", payload);
                if (payload && payload.item) {
                    this.optimisticCartItem = payload.item;
                    this.basketPanelClass = payload.panelClass || "";
                } else {
                    this.optimisticCartItem = payload;
                    this.basketPanelClass = "";
                }
                this.showBasketNotificationOptimistic = true;
            });

            // Listen for basket notification close
            eventBus.on("hide-basket-notification", () => {
                console.log("[BasketNotification] EventBus hide triggered");
                this.showBasketNotificationOptimistic = false;
                this.optimisticCartItem = null;
                this.basketPanelClass = "";
            });

            // Listen for server response - clear optimistic item since cart now has real data
            eventBus.on("clear-optimistic-item", () => {
                console.log("[BasketNotification] Server responded - clearing optimistic item");
                this.optimisticCartItem = null;
            });

            // Email abonelik modal'ını günde bir kez göster (sadece giriş yapmamış kullanıcılar için)
            this.checkAndShowSubscribeModal();
            this.affiliateObj = {
                aktifbank: {
                    logoUrl: "/images/logo_nkolay.png",
                    logoLink: "/",
                    hideTopMenu: true,
                },
                migros: {
                    logoUrl: "/images/logo_migros.png",
                    logoLink: "/",
                    hideTopMenu: true,
                },
            };
        },
        created() {
            this.listenToInertia("navigate", (event) => {
                // Reset basket notification optimistic state on navigation
                this.showBasketNotificationOptimistic = false;
                this.basketPanelClass = "";

                this.institutionalLayout = null;
                this.logoLink = "/";

                this.logoUrl = "/images/logo.png";
                if (event.detail.page.url.startsWith("/kurumsal/kategori") || event.detail.page.url == "/kurumsal" || event.detail.page.url == "/kurumsal-demo" || event.detail.page.url == "/musteri-cozumlerimiz" || event.detail.page.url == "/is-ortagi-cozumlerimiz") {
                    this.logoUrl = "/images/kb-kurumsal.svg";
                    this.logoLink = "/kurumsal";
                    this.institutionalLayout = "demo";
                }

                if (event.detail.page.url.startsWith("/urun")) this.topBannerShow = false;
                if (event.detail.page.url.endsWith("?teknosa")) {
                    this.logoUrl = "https://img-teknosa-sap.mncdn.com/_ui/responsive/theme-teknosa/assets/images/logo.svg";
                    this.hideTopMenu = true;
                    this.logoLink = "https://teknosa.com";
                }

                if (this.$props.affiliate === "aktifbank") {
                    console.log("aktifbank");
                    //this.logoUrl = this.affiliateObj.aktifbank.logoUrl;
                    //this.logoLink = this.affiliateObj.aktifbank.logoLink;
                    //this.hideTopMenu = this.affiliateObj.aktifbank.hideTopMenu;
                    //console.log(this.affiliateObj.aktifbank.logoUrl, this.logoUrl);
                }
                if (this.$props.affiliate === "migros") {
                    console.log("migros");
                    this.logoUrl = this.affiliateObj.migros.logoUrl;
                    //this.logoLink = this.affiliateObj.aktifbank.logoLink;
                    //this.hideTopMenu = this.affiliateObj.aktifbank.hideTopMenu;
                    console.log(this.affiliateObj.migros.logoUrl, this.logoUrl);
                }

                dataLayer.push({
                    pageView: event.detail.page.url,
                    event: "virtualPageView",
                });
            });

            window.axios.defaults.headers.common["Authorization"] = `Bearer ${this.auth.token}`;

            if (this.auth.isUserLoggedIn && this.auth.user == null) {
                axios.get(`${this.apiEP}auth/user/cart/get-auth`).then((res) => {
                    this.auth.user = res.data;
                    const storage = this.getSafeLocalStorage();
                    if (storage) storage.setItem("user", JSON.stringify(res.data));
                });
            } else if (this.auth.isUserLoggedIn && this.auth.user != null) {
                const storage = this.getSafeLocalStorage();
                if (storage) storage.setItem("user", JSON.stringify(this.auth.user));
            }
        },
        // setup() {
        //     const alert = computed(() => usePage().props.flash.alert);
        //     return { alert };
        // },
    };
</script>

<style scoped></style>
